import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TestMode } from "../../@types/general";
import { ISchema } from "../../validation-types/SchemaDefinition";

export interface IGetSubEmployeeChecksParams {
  readonly mode: TestMode;
  readonly employerCheckID?: string;
  readonly q?: string;
}

export const getSubEmployeeChecks = (axios: IAxiosInstance) => {
  return async (params: IGetSubEmployeeChecksParams) => {
    const { mode, employerCheckID, q } = params;
    const response = await axios.noRetry.get<
      ISchema["#/definitions/ISubEmployeeChecksSuccessResponse"]
    >(`/api/getSubEmployeeChecks`, {
      params: { test: mode === TestMode.Test, employerCheckID, q },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
